import "../machineq.scss"
import _ from 'lodash'
import React from "react"
import PropTypes from "prop-types"

export default class MqBaseLayout extends React.Component {
  static propTypes = {
    errSelectors: PropTypes.object.isRequired,
    errActions: PropTypes.object.isRequired,
    specSelectors: PropTypes.object.isRequired,
    oas3Selectors: PropTypes.object.isRequired,
    oas3Actions: PropTypes.object.isRequired,
    getComponent: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    this.setActiveNavSections = _.throttle(this.setActiveNavSections.bind(this), 20);
  }

  componentDidMount() {
    this.setActiveNavSections();
    window.addEventListener('scroll', this.setActiveNavSections);
  }

  setActiveNavSections() {
    const mainSections = document.querySelectorAll('.opblock-tag-section');

    _.forEach(mainSections, mainSection => {
      const {
        height: elHeight,
        top: elOffsetTop
      } = mainSection.getBoundingClientRect();
      const elBottom = elHeight + elOffsetTop;

      if (elOffsetTop < 10 && elBottom > 0) {
        const matchingNavMainSection = mainSection.querySelector('.opblock-tag').getAttribute('id'); // TODO: revisit this
        const dataMainNav = document.querySelector('[href="#' + matchingNavMainSection + '"]');
        const nestedSections = mainSection.querySelectorAll('.opblock-tag + div > .grid');
        const currentActive = document.querySelector('.global-nav__navigation-item--selected');

        if (!_.isNil(currentActive)) currentActive.classList.remove('global-nav__navigation-item--selected');
        if (!_.isNil(dataMainNav)) dataMainNav.classList.add('global-nav__navigation-item--selected');

        _.forEach(nestedSections, nestedSection => {
          const {
            height: elHeight,
            top: elOffsetTop
          } = nestedSection.getBoundingClientRect();
          const elBottom = elHeight + elOffsetTop;

          if (elOffsetTop < 10 && elBottom > 0) {
            const matchingNestedNavMainSection = nestedSection.getAttribute('id'); // TODO: revisit this
            const dataNestedMainNav = document.querySelector('[href="#' + matchingNestedNavMainSection + '"]');
            const currentNestedActive = document.querySelector('.global-nav__nested-item > a._active-nav');

            if (!_.isNil(currentNestedActive)) currentNestedActive.classList.remove('_active-nav');
            if (!_.isNil(dataNestedMainNav)) dataNestedMainNav.classList.add('_active-nav');
          }
        });
      }
    });
  }

  toggleMobileNav() {
    const nav = document.querySelector(".global-nav");

    if (nav.classList.contains("global-nav--mobile-open")) {
      nav.classList.remove("global-nav--mobile-open");
    } else {
      nav.classList.add("global-nav--mobile-open");
    }
  }

  render() {
    let {specSelectors, getComponent} = this.props

    let SvgAssets = getComponent("SvgAssets")
    let InfoContainer = getComponent("InfoContainer", true)
    let VersionPragmaFilter = getComponent("VersionPragmaFilter")
    let Operations = getComponent("operations", true)
    // let Models = getComponent("Models", true)
    let Row = getComponent("Row")
    let Col = getComponent("Col")
    let ServersContainer = getComponent("ServersContainer", true)
    let Errors = getComponent("errors", true)
    let MqSidebar = getComponent("mqsidebar")

    const SchemesContainer = getComponent("SchemesContainer", true)
    const AuthorizeBtnContainer = getComponent("AuthorizeBtnContainer", true)
    const FilterContainer = getComponent("FilterContainer", true)
    let isSwagger2 = specSelectors.isSwagger2()
    let isOAS3 = specSelectors.isOAS3()

    const isSpecEmpty = !specSelectors.specStr()

    if(isSpecEmpty) {
      let loadingMessage
      let isLoading = specSelectors.loadingStatus() === "loading"
      if(isLoading) {
        loadingMessage = <div className="loading"/>
      } else {
        loadingMessage = <h4>No API definition provided.</h4>
      }

      return (
        <div className="swagger-ui">
          <div className="loading-container">
            {loadingMessage}
          </div>
        </div>
      )
    }

    return (
      <div className="swagger-ui">

        <div className="main">

          <MqSidebar
            toggleMobileNav={this.toggleMobileNav.bind(this)}
            specSelectors={specSelectors}
          />

          <section className="main__content">
            <div className="main__content-inner">
              <div className="main__content-fill">

                <div className="swag-content">

                  <div className="swag-content__nav-toggle">
                    <button type="button" className="global-nav__nav-toggle" onClick={this.toggleMobileNav.bind(this)}>
                      <div className="global-nav__nav-toggle-icon global-nav__navigation-icon">
                        <svg viewBox="0 0 25 25" id="menu" width="100%" height="100%">
                          <path fill="currentColor" d="M 3,12.75 C 2.59,12.75 2.25,12.41 2.25,12 2.25,11.59 2.59,11.25 3,11.25 L 21,11.25 C 21.41,11.25 21.75,11.59 21.75,12 21.75,12.41 21.41,12.75 21,12.75 L 3,12.75 Z M 3,4.75 C 2.59,4.75 2.25,4.41 2.25,4 2.25,3.59 2.59,3.25 3,3.25 L 21,3.25 C 21.41,3.25 21.75,3.59 21.75,4 21.75,4.41 21.41,4.75 21,4.75 L 3,4.75 Z M 3,20.75 C 2.59,20.75 2.25,20.41 2.25,20 2.25,19.59 2.59,19.25 3,19.25 L 21,19.25 C 21.41,19.25 21.75,19.59 21.75,20 21.75,20.41 21.41,20.75 21,20.75 L 3,20.75 Z M 3,20.75"/>
                        </svg>
                      </div>
                      <span className="vh">Expand Menu</span>
                    </button>
                  </div>

                  <SvgAssets />
                  <VersionPragmaFilter isSwagger2={isSwagger2} isOAS3={isOAS3} alsoShow={<Errors/>}>
                    <Errors/>
                    <Row className="information-container">
                      <Col mobile={12}>
                        <InfoContainer/>
                      </Col>
                    </Row>

                    <Row>
                      <Col mobile={12} desktop={12} >
                        <div className="authorize-container">
                          <h3>Authorize</h3>
                          <p>In order to use the "Try It Out" feature, you'll have to authorize before sending any requests. Click the button below and you will be redirected to a login page.</p>
                          <AuthorizeBtnContainer />
                          <p>Once you're comfortable testing the API here, you can incorporate these APIs in your own application. Click <a href="https://support.machineq.com/s/article/Signing-In-with-MQ-API" target="_blank">here</a> for details on how to authenticate.</p>
                        </div>
                      </Col>
                    </Row>

                    <FilterContainer/>

                    <Row>
                      <Col mobile={12} desktop={12} >
                        <Operations/>
                      </Col>
                    </Row>
                  </VersionPragmaFilter>

                </div>
              </div>
            </div>
          </section>

        </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/machineq/components/MqBaseLayout.jsx